import { Alert, Stack, Typography } from "@mui/material";

import { CopyCodeBlock } from "../../../../Components/CopyCodeBlock/CopyCodeBlock";

const deleteAgentCommand = `
kubectl delete namespace perfectscale
`.trim();

const DeleteAgent = () => (
  <Stack spacing={4}>
    <Alert severity="warning">
      By deleting the namespace, you will remove the agent from your cluster and stop all data transmission
    </Alert>

    <Stack spacing={2}>
      <Typography>1. Delete the namespace from your cluster.</Typography>
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Delete namespace
        </Typography>
        <Typography>
          <CopyCodeBlock base={deleteAgentCommand} />
        </Typography>
      </Stack>
    </Stack>
  </Stack>
);

export default DeleteAgent;
